// uteblivetApi.js - uteblivit-räknare och bekräftelsetext för uteblivet (Spår U)

import apiClient from '../../apiClient';

// Antal uteblivna besök (enskilda + gruppdeltaganden) senaste `months`
// månaderna, samt vad ett uteblivet på `date` skulle kosta (åldersundantag).
export const getNoShowSummary = async (patientId, { months = 12, date = null, timeout } = {}) => {
  const params = { months };
  if (date) params.date = String(date).slice(0, 10);
  const response = await apiClient.get(`/api/calendar/patients/${patientId}/no-show-summary`, { params, timeout });
  return response.data;
};

// "Uteblivit 2 ggr senaste året" (null när patienten inte uteblivit)
export const noShowCountLabel = (count, months = 12) => {
  if (!count) return null;
  const period = months === 12 ? 'senaste året' : `senaste ${months} mån`;
  return `Uteblivit ${count} ${count === 1 ? 'gång' : 'ggr'} ${period}`;
};

const STANDARD_TEXT = 'Uteblivet-avgiften läggs i dagskassan och fakturaunderlag mailas till fakturamottagaren.';

// Bekräftelsetext inför registrering av uteblivet. Hämtar åldersundantaget
// för besöksdatumet; faller tillbaka på standardtexten om det inte går.
export const uteblivetBekraftelseText = async (fraga, patientId, startTime) => {
  if (!patientId) return `${fraga} ${STANDARD_TEXT}`;
  try {
    // Kort timeout: bekräftelsen får inte hänga på ett segt anrop
    const { uteblivet: u } = await getNoShowSummary(patientId, { date: startTime, timeout: 4000 });
    if (u.avgiftsfri) {
      return `${fraga} Uteblivet registreras utan avgift (patienten är ${u.alder} år) och inget fakturaunderlag skickas.`;
    }
    const belopp = `${Number(u.belopp).toLocaleString('sv-SE')} kr`;
    const okand = u.regel_aktiv && u.alder_okand
      ? '\n\nObs: patientens ålder kunde inte avgöras ur personnumret, så åldersundantaget kan inte tillämpas.'
      : '';
    return `${fraga} Uteblivet-avgiften (${belopp}) läggs i dagskassan och fakturaunderlag mailas till fakturamottagaren.${okand}`;
  } catch (err) {
    console.error('Kunde inte hämta uteblivet-avgift:', err);
    return `${fraga} ${STANDARD_TEXT}`;
  }
};
